import { TenantPermissions, UserDetailDto } from '@artemis-software/wr-api';
import { CanActivateFn, Router } from '@angular/router';
import { CurrentUserService } from '@services/current-user.service';
import { inject } from '@angular/core';

export function permissionGuard(permission: keyof TenantPermissions): CanActivateFn {
  return async () => {
    const currentUserService = inject(CurrentUserService);
    const router = inject(Router);

    await currentUserService.waitForUser();

    if (currentUserService.hasPrivilege(permission)) {
      return true;
    }

    return router.createUrlTree(['/']);
  };
}

export const tgaPermissionGuard: CanActivateFn = async () => {
  const currentUserService = inject(CurrentUserService);
  const router = inject(Router);

  await currentUserService.waitForUser();

  if (currentUserService.canViewTgas()) {
    return true;
  }

  return router.createUrlTree(['/']);
};

export function tenantTypeGuard(tenantType: UserDetailDto.TenantTypeEnum): CanActivateFn {
  return async () => {
    const currentUserService = inject(CurrentUserService);
    const router = inject(Router);

    const user = await currentUserService.waitForUser();

    if (user?.tenantType === tenantType) {
      return true;
    }

    return router.createUrlTree(['/']);
  };
}
